import axios from 'axios';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import type {
  SearchPatientDetailsByDocumentIdResponse,
  SearchPatientDetailsByDocumentIdPayload,
} from './Model';

type InitialState = {
  loading: boolean;
  response: SearchPatientDetailsByDocumentIdResponse;
  successMsg: string;
  error: string;
};

const initialState: InitialState = {
  loading: false,
  response: {} as SearchPatientDetailsByDocumentIdResponse,
  successMsg: '',
  error: '',
};

export const searchPatientDetailsByDocumentId = createAsyncThunk<
  SearchPatientDetailsByDocumentIdResponse,
  SearchPatientDetailsByDocumentIdPayload
>(
  'searchPatientDetailsByDocumentId/searchPatientDetailsByDocumentId',
  async (payload: SearchPatientDetailsByDocumentIdPayload, { rejectWithValue }) => {
    try {
      // Basic Auth Credentials
      const username = 'admin';
      const password = 'Admin123';
      const authHeader = 'Basic ' + btoa(`${username}:${password}`);

      const response = await axios.get(
        'https://ehr-arogya.technicise.eu/openmrs/ws/rest/v1/patient',
        {
          params: { identifier: payload.documentIDNumber },
          headers: {
            Accept: 'application/json',
            Authorization: authHeader,
          },
        },
      );

      return response.data;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.error?.message || 'Failed to fetch patient data',
      );
    }
  },
);

const searchPatientDetailsByDocumentIdSlice = createSlice({
  name: 'searchPatientDetailsByDocumentId',
  initialState,
  reducers: {
    updateSearchPatientDetailsByDocumentIdClearMsg: (state) => {
      state.successMsg = '';
      state.error = '';
    },
    updateSearchPatientDetailsByDocumentIdClearRes: (state) => {
      state.successMsg = '';
      state.error = '';
      state.response = {} as SearchPatientDetailsByDocumentIdResponse;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(searchPatientDetailsByDocumentId.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      searchPatientDetailsByDocumentId.fulfilled,
      (state, action: PayloadAction<SearchPatientDetailsByDocumentIdResponse>) => {
        state.loading = false;
        state.response = action.payload;
        state.successMsg = 'Patient details fetched successfully';
      },
    );
    builder.addCase(searchPatientDetailsByDocumentId.rejected, (state, action) => {
      state.loading = false;
      state.response = {} as SearchPatientDetailsByDocumentIdResponse;
      state.successMsg = '';
      state.error = String(action.payload) || 'Something went wrong';
    });
  },
});

export const {
  updateSearchPatientDetailsByDocumentIdClearMsg,
  updateSearchPatientDetailsByDocumentIdClearRes,
} = searchPatientDetailsByDocumentIdSlice.actions;
export default searchPatientDetailsByDocumentIdSlice.reducer;
